import { useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { Button } from '@/components/ui/button';
import { toast } from 'sonner';

export const QuickImageUpdater = () => {
  const [isUpdating, setIsUpdating] = useState(false);

  const applyUpdates = async () => {
    setIsUpdating(true);
    try {
      const updates = [
        { listing_number: "51022", image_url: "/images/test-listings/car-wash.jpg" },
        { listing_number: "51023", image_url: "/images/test-listings/painting-services.jpg" },
        { listing_number: "51027", image_url: "/images/test-listings/plumbing.jpg" },
        { listing_number: "51045", image_url: "/images/test-listings/education-training.jpg" },
        { listing_number: "51046", image_url: "/images/test-listings/gift-shop.jpg" },
        { listing_number: "51058", image_url: "/images/test-listings/car-detailing.jpg" },
        { listing_number: "51061", image_url: "/images/test-listings/cafe-interior.jpg" },
        { listing_number: "51065", image_url: "/images/test-listings/mobile-mechanic.jpg" },
        { listing_number: "51068", image_url: "/images/test-listings/marketing-agency.jpg" },
      ];

      const { data, error } = await supabase.rpc('update_listing_images_by_number', {
        updates: updates
      });

      if (error) throw error;

      // Invalidate cache
      await supabase.functions.invoke('invalidate-cache', {
        body: { paths: ['/explore', '/explore/page/2', '/explore/page/3', '/explore/page/4', '/explore/page/5'] }
      });

      const result = data as any;
      toast.success(`Updated ${result?.updated_count || 0} listings!`);
      console.log('Update result:', data);
    } catch (error: any) {
      console.error('Update error:', error);
      toast.error(error.message || 'Failed to update images');
    } finally {
      setIsUpdating(false);
    }
  };

  return (
    <div className="p-4 border rounded-lg">
      <h3 className="font-semibold mb-2">Quick Image Updater</h3>
      <p className="text-sm text-muted-foreground mb-4">
        Update images for listings: 51022, 51023, 51027, 51045, 51046, 51058, 51061, 51065, 51068
      </p>
      <Button onClick={applyUpdates} disabled={isUpdating}>
        {isUpdating ? 'Updating...' : 'Apply Image Updates'}
      </Button>
    </div>
  );
};
